import React from 'react';
import { CheckCircleIcon, XCircleIcon } from '@heroicons/react/24/outline';
import { SystemHealth as SystemHealthType } from '../../types/dashboard';

interface SystemHealthProps {
  health: SystemHealthType;
}

const SystemHealth: React.FC<SystemHealthProps> = ({ health }) => {
  const getStatusColor = (status: string) => {
    switch (status.toLowerCase()) {
      case 'healthy':
      case 'ok':
      case 'operational':
        return 'text-primary-500 dark:text-primary-400';
      case 'warning':
        return 'text-yellow-500 dark:text-yellow-400';
      case 'error':
      case 'failed':
        return 'text-red-500 dark:text-red-400';
      default:
        return 'text-gray-500 dark:text-gray-400';
    }
  };

  const getStatusIcon = (status: string) => {
    const isHealthy = ['healthy', 'ok', 'operational'].includes(status.toLowerCase());
    return isHealthy ? (
      <CheckCircleIcon className="h-5 w-5" />
    ) : (
      <XCircleIcon className="h-5 w-5" />
    );
  };

  const StatusItem = ({ label, status }: { label: string; status: string }) => (
    <div className="flex items-center justify-between p-4 rounded-xl bg-light-card dark:bg-dark-card border border-light-border dark:border-dark-border">
      <span className="text-sm font-medium text-gray-700 dark:text-gray-300">
        {label}
      </span>
      <div className={`flex items-center gap-2 ${getStatusColor(status)}`}>
        {getStatusIcon(status)}
        <span className="text-sm font-medium capitalize">
          {status}
        </span>
      </div>
    </div>
  );

  return (
    <div className="chart-container">
      <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-6">
        System Health
      </h3>
      
      <div className="space-y-4">
        <StatusItem 
          label="Overall Status" 
          status={health.status} 
        />
        <StatusItem 
          label="Database Connection" 
          status={health.database_connection} 
        />
        <StatusItem 
          label="API Status" 
          status={health.api_status} 
        />
        
        <div className="mt-6 text-sm text-gray-500 dark:text-gray-400">
          Last checked: {new Date(health.last_checked).toLocaleString()}
        </div>
      </div>
    </div>
  );
};

export default SystemHealth;